import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"min-height":"150px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VChart = _resolveComponent("VChart")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$setup.state.loading)
      ? (_openBlock(), _createBlock(_component_VChart, {
          key: 0,
          option: $setup.chart
        }, null, 8, ["option"]))
      : (_openBlock(), _createBlock(_component_Spinner, { key: 1 }))
  ]))
}